// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2":"94920650bd9a98fc","332":"2c22b1e3af8f54ba"}[chunkId] + ".js";
};